<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="CheckRoute()" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-edit"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทสินค้าการถือครอง (วัน):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'holProductTypeId'"
                    :name="'holProductTypeId'"
                    :multiple="true"
                    :select2-options="holProductTypeIdOptions"
                    v-model="holProductTypeId"
                    ref="holProductTypeIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="holProductTypeId"
                    :multiple="true"
                    :options="holProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'holAgentCode'"
                    :name="'holAgentCode'"
                    :multiple="true"
                    :select2-options="holAgentCodeOptions"
                    @selectChange="onHolAgentCodeChange"
                    v-model="holAgentCode"
                    ref="holAgentCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="holAgentCode"
                    @input="onHolAgentCodeChange"
                    :multiple="true"
                    :options="holAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทร้านค้า :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'holShopTypeId'"
                    :name="'holShopTypeId'"
                    :select2-options="holShopTypeIdOptions"
                    :multiple="true"
                    v-model="holShopTypeId"
                    ref="holShopTypeIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="holShopTypeId"
                    :multiple="true"
                    :options="holShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์สินค้า :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'holProductBrandId'"
                    :name="'holProductBrandId'"
                    :select2-options="holProductBrandIdOptions"
                    :multiple="true"
                    v-model="holProductBrandId"
                    ref="holProductBrandIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="holProductBrandId"
                    :multiple="true"
                    :options="holProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ระยะเวลาการถือครอง :</label>
                  <input
                    type="number"
                    id="holHolderTime"
                    name="holHolderTime"
                    v-model="holHolderTime"
                    min="1"
                    class="form-control"
                    placeholder
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'holInActiveStatus'"
                    :name="'holInActiveStatus'"
                    :select2-options="holInActiveStatusOptions"
                    v-model="holInActiveStatus"
                    ref="holInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Holding/Add"
                  tag="button"
                  title="เพิ่มข้อมูลการถือครอง"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MASTER_HOLDING'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลการถือครอง
                </router-link>
                <router-link
                  to="Holding/Import"
                  tag="button"
                  title="Import"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow('MASTER_HOLDING_CREATE')"
                >
                  <i class="fa fa-file-import"></i> Import
                </router-link>
                <router-link
                  to="Holding/Export"
                  tag="button"
                  title="Export"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MASTER_HOLDING'])"
                >
                  <i class="fa fa-file-export"></i> Export
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="holdTable"
              >
                <thead>
                  <tr>
                    <th class="all">ประเภทสินค้าถือครอง</th>
                    <th class="all">ตัวแทนจำหน่าย</th>
                    <th class="all">ประเภทร้านค้า</th>
                    <th class="all">แบรนด์สินค้า</th>
                    <th class="all">ระยะเวลาการถือครอง</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#holdTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/ProductHolder/" + this.data.productHolderID + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#holdTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/ProductHolder/" + this.data.productHolderID + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let HoldActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editHolding" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteHolding" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    editHolding: function() {
      router.push({
        path: `/Master/Holding/Edit/${this.data.productHolderID}`,
      });
    },
    deleteHolding: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบการถือครอง",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลการถือครอง <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้การถือครองนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลการถือครองออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/ProductHolder/" + this.data.productHolderID + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      holProductTypeId: [],
      holProductTypeIdOptions: [],
      holHolderTime: null,
      holAgentCode: [],
      holAgentCodeOptions: [],
      holShopTypeId: [],
      holShopTypeIdOptions: [],
      holProductBrandId: [],
      holProductBrandIdOptions: [],
      holInActiveStatus: null,
      // holProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2ProductBrand",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      holInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.holProductTypeId = [];
      this.holAgentCode = [];
      this.holShopTypeId = [];
      this.holProductBrandId = [];

      $("#holHolderTime").val("");

      //default Active Data
      this.holInActiveStatus = false;
      $("#holInActiveStatus")
        .val(this.holInActiveStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#holdTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#holdTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    onHolAgentCodeChange(state, value) {
      this.holShopTypeId = [];
    },
    CheckRoute() {
      var url = this.$route.path;
      if (url == "/Master/Holding/Edit/" + this.$root.$route.params.id)
        return false;
      else if (url == "/Master/Holding/Import") return false;
      else if (url == "/Master/Holding/Add") return false;
      else return true;
    },
    LoadholProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.holProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadholAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          page: 1,
          department: [],
          province_id: [],
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.holAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadholShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.holShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadholProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2ProductBrand", {
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.holProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.holInActiveStatus = false;
    $("#holInActiveStatus")
      .val(self.holInActiveStatus + "")
      .trigger("change");

    $("#holInActiveStatus").select2({
      tags: true,
      placeholder: "ทั้งหมด",
      allowClear: true,
    });

    self.LoadholProductTypeIdOptions();
    self.LoadholAgentCodeOptions();
    self.LoadholShopTypeIdOptions();
    self.LoadholProductBrandIdOptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#holdTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/ProductHolder/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                ProductTypeId: self.holProductTypeId,
                AgentCode: self.holAgentCode,
                ShopTypeId: self.holShopTypeId,
                ProductBrandId: self.holProductBrandId,
                HolderTime: $("#holHolderTime").val(),
                ActiveStatus: $("#holInActiveStatus").val(),
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "asc"]],
        columns: [
          { data: "productTypeName" },
          { data: "agentCodeName", width: "20%" },
          { data: "shopTypeName" },
          { data: "productBrandName" },
          { data: "holderTime" },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "ProductHolderID",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_HOLDING",
            ]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_HOLDING",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_HOLDING",
            ]);
            new HoldActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Holding/HoldingList.vue